import styled, { css } from 'styled-components'
import { breakpoint } from '../layout/styles'
import { Container } from '../styles/Container'
import { Grid, Cell } from '../styles/Grid'
import ReactHtmlParser from 'react-html-parser'

const TwoColumnGrid = ({ data }: any) =>
  <StyleWrapper  dark={data.style === 'dark'}>
    <Wrapper>
      {data.title && <SectionTitle>{data.title}</SectionTitle>}
      <Grid>
        {data.items.map((item: any) =>
          <Section md={6} key={item._metadata.uid}>
            <img src={`${item.image?.url}?height=${350}&auto=webp&format=pjpg&quality=75`} />
            {item.title && <h4>{item.title}</h4>}
            {item.description && ReactHtmlParser(item.description)}
          </Section>)}
      </Grid>
    </Wrapper>
  </StyleWrapper>

export default TwoColumnGrid

const Wrapper = styled<any>(Container)`
  margin: 64px 20px;
  @media ${breakpoint.desktop} {
    margin: 100px auto 48px;
  }
`


const Section = styled(Cell)`
  margin: 16px 0;
  color: var(--text);
  @media ${breakpoint.desktop} {
    width: 33.3333%;
    margin: 48px 36px;
  }
  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }
  img {
    display: block;
    margin: 0 auto;
    width: 100%;
    @media ${breakpoint.desktop} {
      height: 268px;
    }
    object-fit: cover;
    object-position: center center;
  }
  h4 {
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
  }
  p {
    font-size: 14px;
    @media ${breakpoint.desktop} {
      font-size: 16px;
    }
  }
`
const SectionTitle = styled.h3`
  margin: 16px 0;
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  @media ${breakpoint.desktop} {
    margin: 48px 0 0 0;
    font-size: 36px;
  }
`

const StyleWrapper = styled.div<any>`

  padding: 1px;
  @media ${breakpoint.desktop} {
    padding: 0;
  }

  ${props => props.dark && css`
    --text: white;
    background: #000;
    margin: 0;
    @media ${breakpoint.desktop} {
      padding: 32px 0;
    }

    .cta {
      background: white !important;
      color: black !important;
      font-weight: bold;
    }
    
    ${Section} {
      display: flex;
      flex-direction: column;
      margin-top: 0;
      margin-bottom: 0;
      h4 {
        order: -1;
        color: #FFF200;
        font-size: 34px;
        line-height: 40px;
        margin-top: 0;
      }
      img {
        margin-bottom: 20px;
      }
    }
  `}
`